import React from 'react'
import styled, { useTheme } from 'styled-components'


import { Flex } from '../styleguide/layout'
import { Img } from '../specified/home/LowTransaction'
import { H3, Span } from '../styleguide/typography'

import AppStoreLinks from './AppStoreLinks'

// images
import appScreen from "../../assets/app-screen.png"
import arrowRightDown from "../../assets/arrow-right-down.png"

const Cta = () => {

  const theme = useTheme()

  return (
    <Flex
        width="100%" 
        margin="5rem 0" 
        borderRadius="1rem" 
        bg={theme.colors.lighterGray} 
        minh="480px" 
        padding="2.5rem 6rem 0 8.75rem"
		justify="center"
		items="center"
        gap="4.5rem" 
        position="relative"
        directionMobile="column"
        paddingMobile="2.5rem 2.5rem 0 2.5rem"
    >
			<Img src={appScreen} alt="low transaction" />

			<Flex width="100%" maxw="400px" direction="column" gap="1.4rem" margin="7.25rem 0 0 0" marginMobile="0">
				<H3 alignMobile="center" width="100%" maxWidth="370px" textTransform="uppercase" mobileSize=".85rem">
					Download Our Mobile App 
				</H3>
				<Span alignMobile="center" maxWidth="430px">
					Download our mobile app on the App Store and Playstore, Trusted by 
					70M+ traders, major banks, institutional and renowned investors, 
					and hedge funds.
				</Span>

				<AppStoreLinks />
			</Flex>

      <PosImage src={arrowRightDown} alt="arrow" />
    </Flex>
  )
}

export default Cta

const PosImage = styled.img`
	position: absolute;
	top: 3rem;
	left: 43rem;
	width: 6rem;
	height: auto;

	@media (max-width: 768px) {
		display: none;
	}
`